import { AxiosInstance } from 'axios';
import type { IMaintenanceWindow } from '@zero-dash/types';

export interface IMaintenanceClient {
  getEvent(signal?: AbortSignal): Promise<IMaintenanceWindow | null>;
}

export function createMaintenanceClient(instance: AxiosInstance): IMaintenanceClient {
  async function getEvent(signal?: AbortSignal): Promise<IMaintenanceWindow | null> {
    const resp = await instance.get('/maintenance/event', { signal });
    return resp.data || null;
  }

  return { getEvent };
}
